// Static modal config for all sample products
const sampleModalConfig = {
  fields: [
    {
      type: "dimensions",
      label: "Dimensions",
      keys: ["H", "W", "D"],
      values: ["2000", "1200", "500"],
    },
    {
      type: "dropdown",
      label: "Shutter Color",
      options: [
        "Advance 1002 Arctic White AR 1.5mm",
        "Advance 1012 Petrol Blue AR 1.5mm",
        "Advance 5072 Raymond Fabric Grey TE 1.0mm",
        "Advance 5073 Raymond Fabric Blue TE 1.0mm",
        "Advance 5113 Red Gate Dark SF 1.0mm",
        "Advance 5117 Perry Light VZ 1.0mm",
        "Advance 5127 Chesterfield Metallic CW 1.0mm",
        "Advance 5137 Dark Straight Walnut SF 1.0mm",
        "Advance 638 Frosty White UL 1.0mm",
        "Catch Line 1019 SF 0.7mm",
        "Catch Line 102 Egg White SF 0.7mm",
        "Catch Line 1087 SF 0.7mm",
        "Catch Line 114 SF 0.7mm",
        "Catch Line 202 Fabric SF 0.7mm",
        "Catch Line 242 SF 0.7mm",
        "Catch plus 8109 Staturio Prime CS 0.8mm",
        "Catch plus 8112 Visconti Tanned CS 0.8mm",
        "Catch plus 8128 Antique Light HG 0.8mm",
        "Catch plus 9109 Off White HG 0.8mm",
        "Catch plus 9109 Off White PU 0.8mm",
        "Catch plus 9111 Grey HG 0.8mm",
        "Century 163 Beige SF 1.0mm",
        "Century 225 Silver Grey SF 1.0mm",
        "Century 227 Moon Grey SF 1.0mm",
        "Century 261 Lavender SF 1.0mm",
        "Century 3531 Tyrol Pine SF 1.0mm",
        "Century 3871 Punto Miro SU 1.0mm",
        "Century 4395 Brink Oak SU 1.0mm",
        "Century 4395 Tohu Miro SU 1.0mm",
        "Century 93877 Light Kain PE 1.0mm",
        "Century 963 Copper Shimmer TS 1.0mm",
        "Century 963 Copper Shimmer TS 1.0mm",
        "Century Starline 84848 Estrie Marble GL 0.8mm",
        "Century Starline 84851 Modern Marmor GL 0.8mm",
        "Dorby 12 Minerva WVD 1.0mm",
        "Dorby 139 Chic Green SF 1.0mm",
        "Dorby 156 Sea Pearl HG 1.0mm",
        "Dorby 156 Sea Pearl SF 1.0mm",
        "Dorby 1569 Live Walnut CD 1.0mm",
        "Dorby 167 Brick Brown ZM 1.0mm",
        "Dorby 2 Milano LTD 1.0mm",
        "Dorby 3 Ritz LTD 1.0mm",
        "Dorby 828 Warm Coal WG 0.8mm",
        "Dorby 853 Moldau Acacia SF 0.8mm",
        "Dorby Digital 916 Spiderman HGL 1.0mm",
        "Greenlam 243 SEA GREEN HDG 1.0mm",
        "Greenlam 247 Dutch Green SUD 1.0mm",
        "Greenlam 248 Leaf Green SUD 1.0mm",
        "Greenlam Greentouch 1101 White PGL 0.8mm",
        "Greenlam Greentouch 1113 Frosty White PGL 0.8mm",
        "Greenlam Greentouch 1113 Frosty White SUD 0.8mm",
        "Greenlam Greentouch 1208 Mango PGL 0.8mm",
        "Greenlam Greentouch 1282 Light Blue SUD 0.8mm",
        "Greenlam Greentouch 1283 Sky Blue SUD 0.8mm",
        "Greenlam Greentouch 1308 Lilac SUD 0.8mm",
        "Greenlam Greentouch 1313 Cloud Grey PGL 0.8mm",
        "Greenlam Greentouch 1565 Pale Herringbone SF",
        "Greenlam Greentouch 1882 Serena Walnut Brown EBK 0.8mm",
        "Merino 10077 Portland Maple SF 1.0mm",
        "Merino 10523 Tigress Teak SF 1.0mm",
        "Merino 10657 Japanese Bamboo SF 1.0mm",
        "Merino 14531 Arizona Black Walnut VNR 1.0mm",
        "Merino 14538 American Walnut VNR 1.0mm",
        "Merino 14546 American Koawood SF 1.0mm",
        "Merino 22291 Frosty White SF 0.7mm",
        "Merino 22291 Frosty White SF 0.8mm",
        "Merino 44766 Antique LNN 1.0mm",
        "Merino 44766 Antique SF 1.0mm",
        "Merino 49978 Aluwave Alumina Pearl HGL 1.0mm",
        "Merino 49978 Aluwave Alumina Pearl SF 1.0mm",
        "Virgo 179 Frosty White PR UC 1.0mm",
        "Virgo 6346 Deco Walnut Brown SHG 1.0mm",
        "Virgo Croma 829 Snuff Elm AHG 1.0mm",
        "Virgolam 1395 Crimson Resonance HG 0.8mm",
        "Virgolam 2871 Taupe Fabric SF 0.8mm",
        "Virgolam 2952 Russian Walnut Cherry HG 0.8mm",
        "Virgolam 2952 Russian Walnut Cherry SF 0.8mm",
        "Virgolam 3117 Daisy White HG 0.8mm",
        "Virgolam 3118 Palm Green HG 0.8mm",
        "Virgolam 3119 Pacific Blue HG 0.8mm",
      ],
    },
    {
      type: "dropdown",
      label: "Inner Color",
      options: [
        "Airolam 6673 SF 0.7mm",
        "Airolam Liner 104 Frosty White SF 0.7mm",
        "Catch Line 1019 SF 0.7mm",
        "Catch Line 107 SF 0.7mm",
        "Catch Line 1087 SF 0.7mm",
        "Catch Line 111 SF 0.7mm",
        "Catch Line 112 SF 0.7mm",
        "Catch Line 113 SF 0.7mm",
        "Catch Line 114 SF 0.7mm",
        "Catch Line 210 SF 0.7mm",
        "Catch Line 231 SF 0.7mm",
        "Catch Line 241 SF/MF 0.7mm",
        "Catch Line 242 SF 0.7mm",
        "Catch Line 256 SF 0.7mm",
        "Virgo 1008 Grey SF 0.7mm",
        "Virgo 2155 Wenge SF/MF 0.7mm",
        "Virgo 2614 Fabric Chicom SF 0.7mm",
        "Virgo 2614 Fabric Chicom SF/MF 0.7mm",
        "Virgo 2708 Highland Pine 0.7mm",
        "Virgo 2872 Bavarian Beech SF/MF 0.7mm",
        "Virgo Croma 2617 Liner SF 0.7mm",
        "Virgo Liner 1008 Grey SF 0.7mm",
        "Virgo Liner 1909 Half White SF 0.7mm",
        "Virgo Liner 2615 Fabric Combi SF/MF 0.7mm",
        "Virgo Liner 2632 Fabric SF 0.7mm",
        "Virgo Liner 2633 Linen Fabric SF/MF 0.7mm",
        "Virgo Liner 2634 Fabric Linen SF 0.7mm",
      ],
    },
    {
      type: "button-group",
      label: "Carcass Material",
      options: ["MR", "BWP", "HDHMR", "WPC", "Other"],
    },
    {
      type: "button-group",
      label: "Shutter Material",
      options: ["MR", "BWP", "HDHMR", "WPC", "Other"],
    },
    {
      type: "dropdown",
      label: "Hinges & Runners",
      options: [
        "Ebco Normal Close",
        "Ebco Soft Close",
        "Hettich Normal Close (Onsys)",
        "Hettich Soft Close (Onsys)",
        "Hafele Normal Close",
        "Hafele Soft Close",
        "Hepo Normal Close",
        "Hepo Soft Close",
        "Blum Soft Close",
      ],
    },
    {
      type: "toggle",
      label: "Minifix",
      options: ["Yes", "No"],
    },
    {
      type: "button-group",
      label: "Exposed Sides",
      options: ["Left", "Right", "Top", "Bottom", "Back"],
    },
  ],
};

export default sampleModalConfig;
